import { BaseMethod } from "./_Base";
import { Poly } from "../../Poly";
export class PlayerModeExpression extends BaseMethod {
  constructor() {
    super(...arguments);
    this._requireDependency = true;
  }
  static requiredArguments() {
    return [];
  }
  async processArguments(args) {
    return Poly.playerMode();
  }
}
